export enum FormEventType {
  Completed = 'completed',
}

export class FormEvent {
  type: FormEventType;
}
